// Campaign attribution for the tradies.remotequote.io split test.
// captureRqUtms() stores UTM + rq_* URL params in localStorage with a 30 day TTL.
// getRqAttribution() returns them if still fresh. Latest click wins on overwrite.
// Attribution must never break the app, every path is wrapped and silent on failure.

const KEY = "rq_attribution";
const KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_variant",
  "utm_term",
  "rq_sid",
  "rq_variant",
];

export function captureRqUtms() {
  try {
    const params = new URLSearchParams(window.location.search);
    const captured = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) captured[k] = v;
    });
    if (Object.keys(captured).length === 0) return;
    captured._captured_at = Date.now();
    captured._expires_at = Date.now() + 30 * 24 * 60 * 60 * 1000;
    localStorage.setItem(KEY, JSON.stringify(captured));
  } catch (_) {
    // Never let attribution capture break page load.
  }
}

export function getRqAttribution() {
  try {
    const attr = JSON.parse(localStorage.getItem(KEY) || "null");
    if (attr && attr._expires_at > Date.now()) return attr;
  } catch (_) {
    // Ignore malformed or unavailable storage.
  }
  return null;
}
